import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  StyledCompletAdressText,
  StyledCompletAdressWrap,
  StyledCompletAdressButton,
  StyledAdressInput
} from './style';

class TrafficConfigAdress extends Component {
  constructor(props) {
    super(props);
    const { address } = props;
    this.state = {
      value: address
    };
  }

  onInputChange = value => {
    this.setState({
      value
    });
  };

  onHandleSave = () => {
    const { onSave } = this.props;
    const { value } = this.state;
    onSave(value);
  };

  render() {
    const { value } = this.state;
    return (
      <StyledCompletAdressWrap>
        <StyledCompletAdressText>Dirección de casa:</StyledCompletAdressText>
        <StyledAdressInput
          placeholder="Dirección"
          value={value}
          onChange={this.onInputChange}
        />
        <StyledCompletAdressButton dark onClick={this.onHandleSave}>
          Guardar
        </StyledCompletAdressButton>
      </StyledCompletAdressWrap>
    );
  }
}

TrafficConfigAdress.propTypes = {
  onSave: PropTypes.func,
  address: PropTypes.string
};

export default TrafficConfigAdress;
